(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
function ledhutFooterGroups(root) {
  const groups = root.querySelectorAll('.lf-group');
  if (!groups.length) return;
  const media = window.matchMedia('(min-width: 981px)');
  const sync = () => groups.forEach(group => { group.open = media.matches; });
  sync();
  media.addEventListener('change', sync);
  groups.forEach(group => group.querySelector('summary').addEventListener('click', event => {
    if (media.matches) event.preventDefault();
  }));
}
ledhutFooterGroups(document);
document.addEventListener('shopify:section:load', event => ledhutFooterGroups(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ledhut-collection"]) return;
  try {
    
(() => {
  const desktop = window.matchMedia('(min-width: 1000px)');
  const isCollectionDrawer = element =>
    element instanceof HTMLElement &&
    element.id === 'slideout-collection-sidebar' &&
    element.closest('.ledhut-collection');
  const closeDesktopDrawer = () => {
    if (!desktop.matches) return;
    document.querySelectorAll('.ledhut-collection #slideout-collection-sidebar').forEach(drawer => {
      if (drawer.matches(':popover-open')) drawer.hidePopover();
    });
  };
  document.addEventListener('beforetoggle', event => {
    if (desktop.matches && event.newState === 'open' && isCollectionDrawer(event.target)) {
      event.preventDefault();
    }
  }, true);
  desktop.addEventListener('change', closeDesktopDrawer);
  closeDesktopDrawer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ledhut-search"]) return;
  try {
    
document.querySelectorAll('[data-lh-product-search]').forEach(function(section) {
  const url = new URL(window.location.href);
  if (url.searchParams.get('type') !== 'product') {
    url.searchParams.set('type', 'product');
    url.searchParams.delete('page');
    window.location.replace(url.href);
  }
});

  } catch(e) { console.error(e); }
})();
})();
